/* Comfort+ listicle (page.listicle-cp): review rail arrows and the offer-box deal timer. */
(() => {
  /* Review rails: arrows scroll by one card */
  document.querySelectorAll('[data-cl-rail]').forEach((rail) => {
    const wrap = rail.parentElement;
    const step = () => {
      const first = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth;
    };
    wrap.querySelector('[data-cl-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    wrap.querySelector('[data-cl-next]')?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Deal timer: reuses the Fall Sale bar's per-visitor end time
     (localStorage key vy_cd_end_<hours>), so both show the same countdown. */
  document.querySelectorAll('[data-cl-cd]').forEach((el) => {
    const hours = parseFloat(el.dataset.clCdHours || '0');
    if (!(hours > 0)) return;
    const ms = hours * 3600 * 1000;
    const key = 'vy_cd_end_' + hours;
    let end;
    try {
      const saved = parseInt(localStorage.getItem(key), 10);
      end = saved > Date.now() ? saved : Date.now() + ms;
      localStorage.setItem(key, String(end));
    } catch (e) { end = Date.now() + ms; }
    const out = el.querySelector('[data-cl-cd-out]');
    const pad = (n) => String(n).padStart(2, '0');
    let timer = 0;
    const tick = () => {
      const left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      out.textContent = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
    };
    timer = setInterval(tick, 1000);
    tick();
  });
})();
